import { createContext, useContext } from "react";
import type { Guide } from "./guides";

/**
 * The open guide, held by the flow rather than by a step. The sidebar pushes the step
 * aside instead of covering it, so it has to live outside the step it belongs to, while
 * the panel that lists the guides sits beside that step.
 */
export const GuideContext = createContext<{
  open: Guide | null;
  setOpen: (guide: Guide | null) => void;
} | null>(null);

export const useGuide = () => useContext(GuideContext);
